import React, { Component } from 'react';
import './../../assets/css/App.css';
import CustomChart from './../../component/chart'
import Service from './service';
import HistogramConfFactory from './../../component/histogram/HistogramConfigFactory';
import HistogramEnum from './../../component/histogram/HistogramTypeEnum';

class ChartView extends Component {
    state = {
        emptyTableMessage: 'No data can be found',
        renderChart : false
    }

    componentDidMount () {
        Service.event.onFetchSendShipmentStatsByCountry.add((chartData) => {
            this.setState({
                histogramChartCategoriesList: chartData.categoryList,
                histogramChartSeriesDataList: chartData.seriesDataList,
                renderChart : true
            });
        });

        Service.fetchSendShipmentStatsByCountry(30);
    }

    componentWillUnmount() {

    }

    render() {
        const options = HistogramConfFactory.createHistogram( {
            histogramType: HistogramEnum.ColumnWithDrilldown,
            histogramTitle: "Sent Shipments by Country for the last 30 days (top 20)",
            yAxisTitle: "Number of Sent Shipments by country",
            seriesName1: "Sent Shipments last 30 days",
            categories: this.state.histogramChartCategoriesList,
            seriesData1: this.state.histogramChartSeriesDataList,
        });

        return (
            <div>
                { this.state.renderChart ? <CustomChart options={options}/> : '' }
            </div>
        );
    }
}

export default ChartView;